// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"eJcTf":[function(require,module,exports,__globalThis) {
// i18n.js
//import enUrl from 'raw:../locales/en.json';
//import esUrl from 'raw:../locales/es.json';
// const localeUrls = {
//   en: enUrl,
//   es: esUrl,
// };
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translator", ()=>Translator);
parcelHelpers.export(exports, "i18n", ()=>i18n);
const localeModules = {
    en: {
        common: ()=>require("ce15429cae690b51"),
        home: ()=>require("970566d449a2d08"),
        health: ()=>require("d5042eb9388f6466"),
        edu: ()=>require("7fcf9f1cd0ed08bc"),
        hunger: ()=>require("19823cbfe9b8a2c4"),
        disasters: ()=>require("f9a8f6a8712a50f9"),
        animal: ()=>require("e5a7cce939b1cae5"),
        join: ()=>require("53f970ec608e73f5"),
        auth: ()=>require("abd567b4f0a4a0e3"),
        portal: ()=>require("d4d0e40609df1c04"),
        club: ()=>require("787c448ba5b87420")
    },
    es: {
        common: ()=>require("d54f1279d61ebf82"),
        home: ()=>require("3d9fd0cdfb2901af"),
        health: ()=>require("89209f37f123657c"),
        edu: ()=>require("71914ad825757ee8"),
        hunger: ()=>require("c4713fe35d835a5e"),
        disasters: ()=>require("ca66754bff29952b"),
        animal: ()=>require("3d3b7dbfad23acba"),
        join: ()=>require("d41e13cd9740b55d"),
        auth: ()=>require("53e01d65ee9fe25c"),
        portal: ()=>require("772f0d4986d985de"),
        club: ()=>require("253966a3c4e1410f")
    }
};
class Translator {
    constructor(){
        this.currentTranslations = {};
        this.currentLang = 'en';
        this.userData = {};
        // Define languages your application actually supports
        this.supportedLanguages = [
            'en',
            'es'
        ];
        this.defaultFallbackLanguage = 'en';
        // Toggle this to false in production to keep console clean
        this.debugMode = true;
    }
    setGlobalData(data) {
        this.userData = {
            ...this.userData,
            ...data
        };
    }
    // Define a map of URL keywords to specific page files
    getModulesForCurrentRoute() {
        const path = window.location.pathname;
        // Always load the 'common' module for global layouts (header/footer)
        const modules = [
            'common'
        ];
        // Route matching rules
        if (path === '/' || path.includes('index.html') || path.includes('index2.html') || path.includes('index2')) modules.push('home');
        else if (path.includes('health')) modules.push('health');
        else if (path.includes('edu')) modules.push('edu');
        else if (path.includes('hunger')) modules.push('hunger');
        else if (path.includes('disasters')) modules.push('disasters');
        else if (path.includes('animals')) modules.push('animal');
        else if (path.includes('join')) modules.push('join');
        else if (path.includes('auth')) modules.push('auth');
        else if (path.includes('portal')) modules.push('portal');
        else if (window.__CURRENT_LAYOUT__ === 'club' || path.includes('club') || path.includes('piztio')) modules.push('club');
        return modules;
    }
    // UPDATED: Core string replacement logic with built-in missing key detection
    t(key, elementData = {}) {
        // 1. Check if the key actually exists in our downloaded dictionary file
        if (!this.currentTranslations.hasOwnProperty(key)) {
            if (this.debugMode) console.warn(`[i18n Warning]: Missing translation key "${key}" for language "${this.currentLang}"`);
            // Fallback strategy: return the key text cleanly formatted so the UI layout doesn't break
            // e.g., "missing_key_name" becomes "[missing_key_name]"
            return `[${key}]`;
        }
        let translation = this.currentTranslations[key];
        const combinedData = {
            ...this.userData,
            ...elementData
        };
        Object.keys(combinedData).forEach((placeholder)=>{
            translation = translation.replaceAll(`{${placeholder}}`, combinedData[placeholder]);
        });
        return translation;
    }
    // NEW: Recursive deep scanner that bypasses Shadow DOM boundaries
    translatePage(targetNode = document.body) {
        // 1. If a selector string was passed (like '#greeting'), grab the actual DOM element
        if (typeof targetNode === 'string') targetNode = document.querySelector(targetNode);
        // 2. We extract your exact inner logic into a reusable worker function
        const processElement = (element)=>{
            const textKey = element.getAttribute('data-i18n');
            const attrConfigStr = element.getAttribute('data-i18n-attr');
            const dataAttr = element.getAttribute('data-i18n-data');
            const elementData = dataAttr ? JSON.parse(dataAttr) : {};
            // Handle Standard Inner Text Content Translation
            if (textKey) element.innerHTML = this.t(textKey, elementData);
            // Handle Multiple Attribute Translations Dynamic Setup
            if (attrConfigStr) try {
                const attrMapping = JSON.parse(attrConfigStr);
                Object.keys(attrMapping).forEach((targetHtmlAttr)=>{
                    const dictionaryKey = attrMapping[targetHtmlAttr];
                    const translatedValue = this.t(dictionaryKey, elementData);
                    // 1. Check if we already cached the original value from a previous language switch
                    // const cacheKey = `data-i18n-orig-${targetHtmlAttr}`;
                    // let originalValue = element.getAttribute(cacheKey);
                    // if (originalValue === null) {
                    //   originalValue = element.getAttribute(targetHtmlAttr) || '';
                    //   element.setAttribute(cacheKey, originalValue);
                    // }
                    // const allowableFallbacks = ['', 'from-i18n', '#from-i18n'];
                    // if (
                    //   !originalValue ||
                    //   allowableFallbacks.includes(originalValue.trim())
                    // ) {
                    //   element.setAttribute(targetHtmlAttr, translatedValue);
                    // }
                    element.setAttribute(targetHtmlAttr, translatedValue);
                });
            } catch (e) {
                if (textKey) element.setAttribute(attrConfigStr, this.t(textKey, elementData));
            }
        };
        // 3. Your recursive crawl engine updated with targeted node matching capabilities
        const scanNode = (rootNode)=>{
            if (!rootNode) return;
            // NEW CAPABILITY: If the targeted root element itself has an i18n attribute, translate it
            if (rootNode.hasAttribute?.('data-i18n') || rootNode.hasAttribute?.('data-i18n-attr')) processElement(rootNode);
            // Target any nested child elements matching your setup
            rootNode.querySelectorAll('[data-i18n], [data-i18n-attr]').forEach((element)=>{
                processElement(element);
            });
            // Deep crawl past any open component roots recursively
            rootNode.querySelectorAll('*').forEach((childElement)=>{
                if (childElement.shadowRoot) scanNode(childElement.shadowRoot);
            });
        };
        // 4. Kick off the initial scan starting from your custom target node variable selection
        scanNode(targetNode);
    }
    async changeLanguage(lang, requiredModules = null) {
        try {
            // Fallback validation check
            if (!this.supportedLanguages.includes(lang)) lang = this.defaultFallbackLanguage;
            if (!requiredModules) requiredModules = this.getModulesForCurrentRoute();
            this.currentTranslations = {};
            // 2. Iterate through the requested modules using the static map
            const fetchPromises = requiredModules.map(async (moduleName)=>{
                try {
                    // Verify the requested language and module exist in our map
                    const loadModuleFn = localeModules[lang]?.[moduleName];
                    if (!loadModuleFn) throw new Error(`Module handler not found`);
                    // Trigger the dynamic import function
                    const moduleData = await loadModuleFn();
                    // Merge the downloaded JSON file into active translation dictionary
                    Object.assign(this.currentTranslations, moduleData.default || moduleData);
                } catch (err) {
                    console.error(`[i18n Error] Could not load chunk "${moduleName}" for language "${lang}"`, err);
                }
            });
            await Promise.all(fetchPromises);
            this.currentLang = lang;
            this.translatePage();
            document.documentElement.lang = lang;
            localStorage.setItem('preferredLanguage', lang);
            const event = new CustomEvent('app:lang-changed', {
                detail: {
                    language: lang
                }
            });
            window.dispatchEvent(event);
        } catch (error) {
            console.error('Translation Engine Error:', error);
        }
    }
    // NEW DETECT AND INITIALIZE SYSTEM
    init(dropdownId) {
        // 1. Check if user has an explicit manual save in localStorage
        const savedLang = localStorage.getItem('preferredLanguage');
        // 2. Read browser settings and isolate the first two letters (e.g., "en-US" -> "en")
        const browserLang = navigator.language.slice(0, 2);
        // 3. Determine target language: Saved Preference -> Browser Language -> Default Fallback
        let targetedLanguage = this.defaultFallbackLanguage;
        if (savedLang && this.supportedLanguages.includes(savedLang)) targetedLanguage = savedLang;
        else if (this.supportedLanguages.includes(browserLang)) targetedLanguage = browserLang;
        // 4. Update the visual dropdown selection state matching our decision
        const switcher = document.getElementById(dropdownId);
        if (switcher) {
            switcher.value = targetedLanguage;
            switcher.addEventListener('change', (e)=>this.changeLanguage(e.target.value));
        }
        // 5. Fire up the translation dictionary pipeline
        this.changeLanguage(targetedLanguage);
    }
    initFromElement(switcherElement) {
        const savedLang = localStorage.getItem('preferredLanguage');
        const browserLang = navigator.language.slice(0, 2);
        let targetedLanguage = this.defaultFallbackLanguage;
        console.log('lang chosen: ', targetedLanguage);
        if (savedLang && this.supportedLanguages.includes(savedLang)) targetedLanguage = savedLang;
        else if (this.supportedLanguages.includes(browserLang)) targetedLanguage = browserLang;
        if (switcherElement) {
            switcherElement.value = targetedLanguage;
            switcherElement.addEventListener('change', (e)=>this.changeLanguage(e.target.value));
        }
        this.changeLanguage(targetedLanguage);
    }
}
const i18n = new Translator();

},{"ce15429cae690b51":"210Xa","970566d449a2d08":"kLund","d5042eb9388f6466":"6c8tt","7fcf9f1cd0ed08bc":"dXomi","19823cbfe9b8a2c4":"hz7cT","f9a8f6a8712a50f9":"9KqHt","e5a7cce939b1cae5":"edsDi","53f970ec608e73f5":"fG7zL","abd567b4f0a4a0e3":"fkfZU","d4d0e40609df1c04":"1tz5X","787c448ba5b87420":"kaOVc","d54f1279d61ebf82":"1TVRu","3d9fd0cdfb2901af":"lgACy","89209f37f123657c":"6N6FG","71914ad825757ee8":"ddjB6","c4713fe35d835a5e":"kNUkz","ca66754bff29952b":"l0pZf","3d3b7dbfad23acba":"3dx0w","d41e13cd9740b55d":"axesb","53e01d65ee9fe25c":"6mJrG","772f0d4986d985de":"kfGWW","253966a3c4e1410f":"7uLNw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"210Xa":[function(require,module,exports,__globalThis) {
module.exports = import("iCT9q").then(()=>module.bundle.root('1ePeP'));

},{}],"kLund":[function(require,module,exports,__globalThis) {
module.exports = import("cExMB").then(()=>module.bundle.root('2xUow'));

},{}],"6c8tt":[function(require,module,exports,__globalThis) {
module.exports = import("9yEAu").then(()=>module.bundle.root('dJepa'));

},{}],"dXomi":[function(require,module,exports,__globalThis) {
module.exports = import("7Ayzy").then(()=>module.bundle.root('dl3fb'));

},{}],"hz7cT":[function(require,module,exports,__globalThis) {
module.exports = import("8WaRe").then(()=>module.bundle.root('84LVe'));

},{}],"9KqHt":[function(require,module,exports,__globalThis) {
module.exports = import("ba9qY").then(()=>module.bundle.root('e7JNX'));

},{}],"edsDi":[function(require,module,exports,__globalThis) {
module.exports = import("igsAv").then(()=>module.bundle.root('8blHt'));

},{}],"fG7zL":[function(require,module,exports,__globalThis) {
module.exports = import("aqCft").then(()=>module.bundle.root('745Ev'));

},{}],"fkfZU":[function(require,module,exports,__globalThis) {
module.exports = import("2juQl").then(()=>module.bundle.root('dfzGT'));

},{}],"1tz5X":[function(require,module,exports,__globalThis) {
module.exports = import("8BXoH").then(()=>module.bundle.root('gM92x'));

},{}],"kaOVc":[function(require,module,exports,__globalThis) {
module.exports = import("fke9s").then(()=>module.bundle.root('hhQ9k'));

},{}],"1TVRu":[function(require,module,exports,__globalThis) {
module.exports = import("b4iLT").then(()=>module.bundle.root('5CLTt'));

},{}],"lgACy":[function(require,module,exports,__globalThis) {
module.exports = import("lTG8m").then(()=>module.bundle.root('g6dCj'));

},{}],"6N6FG":[function(require,module,exports,__globalThis) {
module.exports = import("leAWc").then(()=>module.bundle.root('7U5Vy'));

},{}],"ddjB6":[function(require,module,exports,__globalThis) {
module.exports = import("aBr8f").then(()=>module.bundle.root('g2RRh'));

},{}],"kNUkz":[function(require,module,exports,__globalThis) {
module.exports = import("g9cAB").then(()=>module.bundle.root('cJsJ8'));

},{}],"l0pZf":[function(require,module,exports,__globalThis) {
module.exports = import("gwIVj").then(()=>module.bundle.root('ebday'));

},{}],"3dx0w":[function(require,module,exports,__globalThis) {
module.exports = import("592xI").then(()=>module.bundle.root('6pQX5'));

},{}],"axesb":[function(require,module,exports,__globalThis) {
module.exports = import("eN7op").then(()=>module.bundle.root('6qFtk'));

},{}],"6mJrG":[function(require,module,exports,__globalThis) {
module.exports = import("6avsq").then(()=>module.bundle.root('7lUJQ'));

},{}],"kfGWW":[function(require,module,exports,__globalThis) {
module.exports = import("d3Ruo").then(()=>module.bundle.root('dnGj4'));

},{}],"7uLNw":[function(require,module,exports,__globalThis) {
module.exports = import("bit0h").then(()=>module.bundle.root('4iZBx'));

},{}],"jYzpo":[function(require,module,exports,__globalThis) {
//import phUser from '../images/svg/ph-user.svg';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "saveCookie", ()=>saveCookie);
parcelHelpers.export(exports, "deleteCookie", ()=>deleteCookie);
parcelHelpers.export(exports, "initLangCookie", ()=>initLangCookie);
parcelHelpers.export(exports, "initLangAction", ()=>initLangAction);
parcelHelpers.export(exports, "initFooter", ()=>initFooter);
parcelHelpers.export(exports, "initResponsivecMenu", ()=>initResponsivecMenu);
parcelHelpers.export(exports, "addDonateInfo", ()=>addDonateInfo);
parcelHelpers.export(exports, "role", ()=>role);
parcelHelpers.export(exports, "roleEs", ()=>roleEs);
parcelHelpers.export(exports, "countryEsList", ()=>countryEsList);
parcelHelpers.export(exports, "countryList", ()=>countryList);
parcelHelpers.export(exports, "countryCodeList", ()=>countryCodeList);
parcelHelpers.export(exports, "languages", ()=>languages);
parcelHelpers.export(exports, "userInfo", ()=>userInfo);
parcelHelpers.export(exports, "roleInfo", ()=>roleInfo);
parcelHelpers.export(exports, "roles", ()=>roles);
parcelHelpers.export(exports, "rolesEs", ()=>rolesEs);
parcelHelpers.export(exports, "temp_role", ()=>temp_role);
parcelHelpers.export(exports, "loadCountries", ()=>loadCountries);
parcelHelpers.export(exports, "loadLangsList", ()=>loadLangsList);
parcelHelpers.export(exports, "loadLangList", ()=>loadLangList);
parcelHelpers.export(exports, "getCountryName", ()=>getCountryName);
parcelHelpers.export(exports, "getLanguageName", ()=>getLanguageName);
parcelHelpers.export(exports, "validateEmail", ()=>validateEmail);
parcelHelpers.export(exports, "validateName", ()=>validateName);
parcelHelpers.export(exports, "temp_popLoading", ()=>temp_popLoading);
parcelHelpers.export(exports, "addLoadingPopup", ()=>addLoadingPopup);
parcelHelpers.export(exports, "togglePopLoading", ()=>togglePopLoading);
parcelHelpers.export(exports, "showLoadingPopup", ()=>showLoadingPopup);
parcelHelpers.export(exports, "setInputError", ()=>setInputError);
parcelHelpers.export(exports, "setInputValidity", ()=>setInputValidity);
parcelHelpers.export(exports, "getLoginError", ()=>getLoginError);
parcelHelpers.export(exports, "getRegisterError", ()=>getRegisterError);
parcelHelpers.export(exports, "validatePassword", ()=>validatePassword);
parcelHelpers.export(exports, "togglePopConfirm", ()=>togglePopConfirm);
parcelHelpers.export(exports, "togglePopMsg", ()=>togglePopMsg);
parcelHelpers.export(exports, "createUser", ()=>createUser);
parcelHelpers.export(exports, "createEmptyUser", ()=>createEmptyUser);
parcelHelpers.export(exports, "createEmptyRole", ()=>createEmptyRole);
parcelHelpers.export(exports, "temp_loginPrompt", ()=>temp_loginPrompt);
parcelHelpers.export(exports, "temp_loginForm", ()=>temp_loginForm);
parcelHelpers.export(exports, "toggleLoginForm", ()=>toggleLoginForm);
parcelHelpers.export(exports, "toggleLoginPrompt", ()=>toggleLoginPrompt);
parcelHelpers.export(exports, "check", ()=>check);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "info", ()=>info);
parcelHelpers.export(exports, "elToast", ()=>elToast);
/**
 * Show a snackbar that disappears
 * @param {*} type success, warn, error, info
 * @param {*} msg message to show
 * @param {*} time optional time in milliseconds, default is 3000
 */ parcelHelpers.export(exports, "showToast", ()=>showToast);
parcelHelpers.export(exports, "showMsgLoader", ()=>showMsgLoader);
parcelHelpers.export(exports, "updateMsgLoader", ()=>updateMsgLoader);
parcelHelpers.export(exports, "hideMsgLoader", ()=>hideMsgLoader);
parcelHelpers.export(exports, "createCampaignCard", ()=>createCampaignCard);
parcelHelpers.export(exports, "createMediaItem", ()=>createMediaItem);
parcelHelpers.export(exports, "createImgWrapper", ()=>createImgWrapper);
parcelHelpers.export(exports, "createFileItem", ()=>createFileItem);
parcelHelpers.export(exports, "getFileNameFromUrl", ()=>getFileNameFromUrl);
parcelHelpers.export(exports, "temp_inputEdit", ()=>temp_inputEdit);
parcelHelpers.export(exports, "showInputEdit", ()=>showInputEdit);
parcelHelpers.export(exports, "campaignPrograms", ()=>campaignPrograms);
parcelHelpers.export(exports, "loadCampaignPrograms", ()=>loadCampaignPrograms);
parcelHelpers.export(exports, "programs", ()=>programs);
parcelHelpers.export(exports, "programsEs", ()=>programsEs);
parcelHelpers.export(exports, "status", ()=>status);
parcelHelpers.export(exports, "statusEs", ()=>statusEs);
parcelHelpers.export(exports, "initPrograms", ()=>initPrograms);
parcelHelpers.export(exports, "initStatusOptions", ()=>initStatusOptions);
parcelHelpers.export(exports, "temp_fileUpload", ()=>temp_fileUpload);
parcelHelpers.export(exports, "validateDOB", ()=>validateDOB);
parcelHelpers.export(exports, "formatMoney", ()=>formatMoney);
parcelHelpers.export(exports, "validatePhone", ()=>validatePhone);
parcelHelpers.export(exports, "donee", ()=>donee);
parcelHelpers.export(exports, "newDonee", ()=>newDonee);
parcelHelpers.export(exports, "denied", ()=>denied);
parcelHelpers.export(exports, "newDenied", ()=>newDenied);
parcelHelpers.export(exports, "simpleHelp", ()=>simpleHelp);
parcelHelpers.export(exports, "newSimpleHelp", ()=>newSimpleHelp);
parcelHelpers.export(exports, "donation", ()=>donation);
parcelHelpers.export(exports, "newDonation", ()=>newDonation);
parcelHelpers.export(exports, "helpForm", ()=>helpForm);
parcelHelpers.export(exports, "newHelpForm", ()=>newHelpForm);
parcelHelpers.export(exports, "copyHelpForm", ()=>copyHelpForm);
parcelHelpers.export(exports, "formatInputDate", ()=>formatInputDate);
parcelHelpers.export(exports, "formatDisplayDate", ()=>formatDisplayDate);
parcelHelpers.export(exports, "formatDisplayTime", ()=>formatDisplayTime);
parcelHelpers.export(exports, "temp_helpFormLog", ()=>temp_helpFormLog);
parcelHelpers.export(exports, "createHelpFormLog", ()=>createHelpFormLog);
parcelHelpers.export(exports, "temp_helpFormFile", ()=>temp_helpFormFile);
parcelHelpers.export(exports, "createHelpFormFile", ()=>createHelpFormFile);
/**
 * Converts bytes to a human-readable format.
 * @param {number} bytes The numeric value in bytes.
 * @param {number} decimals How many decimal places to include (default 2).
 */ parcelHelpers.export(exports, "formatBytes", ()=>formatBytes);
parcelHelpers.export(exports, "temp_listItem", ()=>temp_listItem);
parcelHelpers.export(exports, "createAssistItem", ()=>createAssistItem);
parcelHelpers.export(exports, "createHireItem", ()=>createHireItem);
parcelHelpers.export(exports, "showShareModal", ()=>showShareModal);
parcelHelpers.export(exports, "showCampaignCreatedModal", ()=>showCampaignCreatedModal);
parcelHelpers.export(exports, "createInvoiceRow", ()=>createInvoiceRow);
/**
 * Triggers a custom confirmation dialog box.
 * @param {Object} options - Configuration properties.
 * @param {string} options.title - The heading text.
 * @param {string} options.message - The descriptive paragraph text.
 * @param {string} [options.confirmText="Confirm"] - Text for the confirm button.
 * @param {string} [options.cancelText="Cancel"] - Text for the cancel button.
 * @param {string} [options.confirmType="primary"] - Visual style type ('primary' or 'danger').
 * @returns {Promise<boolean>} Resolves to true if confirmed, false if cancelled.
 */ parcelHelpers.export(exports, "showConfirmDialog", ()=>showConfirmDialog);
/**
 * Triggers a custom confirmation dialog box.
 * @param {Object} options - Configuration properties.
 * @param {string} options.title - The heading text.
 * @param {string} options.message - The descriptive paragraph text.
 * @param {string} [options.confirmText="Confirm"] - Text for the confirm button.
 * @param {string} [options.cancelText="Cancel"] - Text for the cancel button.
 * @param {string} [options.confirmType="primary"] - Visual style type ('primary' or 'danger').
 * @returns {Promise<boolean>} Resolves to true if confirmed, false if cancelled.
 */ parcelHelpers.export(exports, "showSingleConfirmDialog", ()=>showSingleConfirmDialog);
parcelHelpers.export(exports, "toggleSkeleton", ()=>toggleSkeleton) // example on how to call a function from function caller
 /**
 * Show a confirmation dialog with message and action buttons
 * @param {*} msg Message to show
 * @param {*} onYes function to fire when yes button clicked
 */  // export function showConfirmModal(title, msg, onYes) {
 //   let confirmModal = document.getElementById("confirmModal");
 //   let pTitle, pMsg, btnNo, btnYes;
 //   if (!confirmModal) {
 //     const container = document.createElement("div");
 //     container.innerHTML = elConfirmModal;
 //     confirmModal = container.firstChild;
 //     document.body.appendChild(confirmModal);
 //   }
 //   pTitle = confirmModal.querySelector(".mod-title");
 //   pMsg = confirmModal.querySelector(".mod-msg");
 //   btnNo = confirmModal.querySelector(".btn-no");
 //   btnYes = confirmModal.querySelector(".btn-yes");
 //   pTitle.textContent = title ? title : "Confirm";
 //   pMsg.textContent = msg;
 //   $(btnYes).on("click", function () {
 //     if (onYes) {
 //       onYes();
 //     }
 //     setDisplay(confirmModal, "none");
 //   });
 //   $(btnNo).on("click", function () {
 //     setDisplay(confirmModal, "none");
 //   });
 //   setDisplay(confirmModal, "flex");
 // }
 // function confirmLogout() {
 //   showConfirmModal(null, "Are you sure you want to logout?", logout);
 // }
 // function logout() {
 //   signOut(auth)
 //     .then(() => {
 //       showToast("success", "Signed out successfully", null);
 //     })
 //     .catch((_e) => {
 //       showToast("error", "Could not sign you out", null);
 //     });
 // }
;
var _translator = require("../custom/translator");
//import phUser from 'url:../images/svg/ph-user.svg';
const phUser = new URL(require("3bfcd557e2b44a66"));
let cookieFbLang = 'firebase-language-override';
function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == ' ')c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
}
function saveCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
function deleteCookie(cname) {
    //document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
function initLangCookie() {
    var lang = getCookie(cookieFbLang);
    if (lang != '') deleteCookie(cookieFbLang);
    return lang || 'en';
}
function initLangAction() {
    $('.dropdown-content a').click(function(event) {
        deleteCookie(cookieFbLang);
        //saveCookie(cookieFbLang, this.title, 365);
        //alert("An external link was clicked!");
        location.reload();
        event.preventDefault();
    });
//   var btnTrans = document.getElementById("btnTranslate");
//   var listRads = document.querySelectorAll(".drop-content input");
//   for (let index = 0; index < listRads.length; index++) {
//     const rad = listRads[index];
//     rad.addEventListener("click", function () {
//       var cvalue = rad.value;
//       saveCookie(cookieFbLang, cvalue, 365);
//       var lbl = document.querySelector(`label.${cvalue}`);
//       $(`#btnTranslate span`).text(lbl.textContent);
//       // var web = `../localized-files/${cvalue}/index.html`;
//       // window.location.replace(web);
//       location.reload();
//     });
//   }
}
function initFooter() {
    var d = new Date();
    var smYear = document.getElementById('smYear');
    if (smYear) smYear.textContent = smYear.textContent.replace('$year', d.getFullYear());
}
function initResponsivecMenu() {
    console.log('started header');
    var aToggle = document.getElementById('aToggle');
    var dMenu = document.querySelector('.header-menu .collapse');
    if (aToggle === null || dMenu === null) return;
    else console.log("header won't click: ");
    console.log('header will click: ');
    aToggle.addEventListener('click', toggleMenu);
    document.body.addEventListener('click', function(event) {
        // Check if the clicked element is NOT the div itself and NOT a child of the div
        if (!aToggle.contains(event.target) && event.target !== aToggle) dMenu.style.display = 'none'; // Hide the div
    });
    document.querySelector('.nav-dropdown').addEventListener('click', function(event) {
        // Stops the click from bubbling up and triggering close actions
        event.stopPropagation();
    });
}
function toggleMenu() {
    var x = document.querySelector('.header-menu .collapse');
    console.log('header clicked: ', x.style.display);
    if (x === null) return;
    if (x.style.display === 'flex') x.style.display = 'none';
    else x.style.display = 'flex';
}
function addDonateInfo() {
    let link = `zeffy-form-link="https://www.zeffy.com/embed/donation-form/donate-to-change-lives-6222?modal=true"`;
}
const role = [
    'Founder & CEO',
    'Ambassador',
    'Director/Official of Communications',
    'Programs & Services',
    'Fundraising & Development',
    'Marketing & Communications',
    'Administrations & Operations'
];
const roleEs = [
    'Fundador y CEO',
    'Embajador',
    'Director/Oficial de Comunicaciones',
    'Programas y Servicios',
    "Recaudaci\xf3n de fondos y Desarrollo",
    'Marketing y Comunicaciones',
    "Administraci\xf3n y operaciones"
];
const countryEsList = [
    "Afganist\xe1n",
    'Albania',
    'Argelia',
    'Samoa Americana',
    'Andorra',
    'Angola',
    'Anguila',
    "Ant\xe1rtida",
    'Antigua y Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    "Azerbaiy\xe1n",
    'Bahamas',
    "Bahr\xe9in",
    'Bangladesh',
    'Barbados',
    'Bielorrusia',
    "B\xe9lgica",
    'Belice',
    'Benin',
    'Islas Bermudas',
    "But\xe1n",
    'Bolivia (Estado Plurinacional de)',
    'Bonaire, Sint Eustatius y Saba',
    'Bosnia y Herzegovina',
    'Botswana',
    'Isla Bouvet',
    'Brasil',
    "Territorio Brit\xe1nico del Oc\xe9ano \xcdndico",
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Camboya',
    "Camer\xfan",
    "Canad\xe1",
    "Islas Caim\xe1n",
    "Rep\xfablica Centroafricana",
    'Chad',
    'Chile',
    'Porcelana',
    'Isla de Navidad',
    'Islas Cocos (Keeling)',
    'Colombia',
    'Comoras',
    "Congo (Rep\xfablica Democr\xe1tica del)",
    'Congo',
    'Islas Cook',
    'Costa Rica',
    'Croacia',
    'Cuba',
    'Curazao',
    'Chipre',
    'Chequia',
    "C\xf4te d'Ivoire",
    'Dinamarca',
    'Djibouti',
    'Dominica',
    "Rep\xfablica Dominicana",
    'Ecuador',
    'Egipto',
    'El Salvador',
    'Guinea Ecuatorial',
    'Eritrea',
    'Estonia',
    'Eswatini',
    "Etiop\xeda",
    'Islas Falkland [Malvinas]',
    'Islas Faroe',
    'Fiji',
    'Finlandia',
    'Francia',
    'Guayana Francesa',
    "Polinesia franc\xe9s",
    'Territorios Franceses del Sur',
    "Gab\xf3n",
    'Gambia',
    'Georgia',
    'Alemania',
    'Ghana',
    'Gibraltar',
    'Grecia',
    'Groenlandia',
    'Granada',
    'Guadalupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guayana',
    "Hait\xed",
    'Islas Heard y McDonald',
    'Santa Sede',
    'Honduras',
    'Hong Kong',
    "Hungr\xeda",
    'Islandia',
    'India',
    'Indonesia',
    "Ir\xe1n (Rep\xfablica Isl\xe1mica de)",
    'Irak',
    'Irlanda',
    'Isla del hombre',
    'Israel',
    'Italia',
    'Jamaica',
    "Jap\xf3n",
    "Su\xe9ter",
    "Jord\xe1n",
    "Kazajst\xe1n",
    'Kenia',
    'Kiribati',
    "Corea (Rep\xfablica Popular Democr\xe1tica de)",
    "Corea (Rep\xfablica de)",
    'Kuwait',
    "Kirguist\xe1n",
    "Rep\xfablica Democr\xe1tica Popular Lao",
    'Letonia',
    "L\xedbano",
    'Lesoto',
    'Liberia',
    'Libia',
    'Liechtenstein',
    'Lituania',
    'Luxemburgo',
    'Macao',
    'Madagascar',
    'Malawi',
    'Malasia',
    'Maldivas',
    "Mal\xed",
    'Malta',
    'Islas Marshall',
    'Martinica',
    'Mauritania',
    'Mauricio',
    'Mayotte',
    "M\xe9xico",
    'Micronesia (Estados Federados de)',
    "Moldova (la Rep\xfablica de)",
    "M\xf3naco",
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Marruecos',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    "Pa\xedses Bajos",
    'Nueva Caledonia',
    'Nueva Zelanda',
    'Nicaragua',
    "N\xedger",
    'Nigeria',
    'Niue',
    'Isla Norfolk',
    'Islas Marianas del Norte',
    'Noruega',
    "Om\xe1n",
    "Pakist\xe1n",
    'Palau',
    'Palestina, Estado de',
    "Panam\xe1",
    "Pap\xfaa Nueva Guinea",
    'Paraguay',
    "Per\xfa",
    'Filipinas',
    'Pitcairn',
    'Polonia',
    'Portugal',
    'Puerto Rico',
    'Katar',
    "Rep\xfablica de Macedonia del Norte",
    'Rumania',
    "Federaci\xf3n Rusa",
    'Ruanda',
    'Cita',
    "San Bartolom\xe9",
    "Santa Elena, Ascensi\xf3n y Tristan da Cunha",
    'Saint Kitts y Nevis',
    "Santa Luc\xeda",
    "San Mart\xedn (parte francesa)",
    "San Pedro y Miquel\xf3n",
    'San Vicente y las Granadinas',
    'Samoa',
    'San Marino',
    "Santo Tom\xe9 y Pr\xedncipe",
    'Arabia Saudita',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leona',
    'Singapur',
    'Sint Maarten (parte holandesa)',
    'Eslovaquia',
    'Eslovenia',
    "Islas Salom\xf3n",
    'Somalia',
    "Sud\xe1frica",
    'Georgia del sur y las islas Sandwich del sur',
    "Sud\xe1n del Sur",
    "Espa\xf1a",
    'Sri Lanka',
    "Sud\xe1n",
    'Surinam',
    'Svalbard y Jan Mayen',
    'Suecia',
    'Suiza',
    "Rep\xfablica \xc1rabe Siria",
    "Taiw\xe1n",
    "Tayikist\xe1n",
    "Rep\xfablica Unida de Tanzan\xeda",
    'Tailandia',
    'Timor-Leste',
    'Ir',
    'Tokelau',
    'Tonga',
    'Trinidad y Tobago',
    "T\xfanez",
    'Pavo',
    "Turkmenist\xe1n",
    'Islas Turcas y Caicos',
    'Tuvalu',
    'Uganda',
    'Ucrania',
    "Emiratos \xc1rabes Unidos",
    "Reino Unido de Gran Breta\xf1a e Irlanda del Norte",
    'Islas menores alejadas de los Estados Unidos',
    'Estados Unidos',
    'Uruguay',
    "Uzbekist\xe1n",
    'Vanuatu',
    "Venezuela (Rep\xfablica Bolivariana de)",
    'Vietnam',
    "Islas V\xedrgenes (Brit\xe1nicas)",
    "Islas V\xedrgenes (EE. UU.)",
    'Wallis y Futuna',
    'Sahara Occidental',
    'Yemen',
    'Zambia',
    'Zimbabue',
    'Islas Aland'
];
const countryList = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia (Plurinational State of)',
    'Bonaire, Sint Eustatius and Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo (the Democratic Republic of the)',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Croatia',
    'Cuba',
    "Cura\xe7ao",
    'Cyprus',
    'Czechia',
    "C\xf4te d'Ivoire",
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Falkland Islands [Malvinas]',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Holy See',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran (Islamic Republic of)',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    "Korea (the Democratic People's Republic of)",
    'Korea (the Republic of)',
    'Kuwait',
    'Kyrgyzstan',
    "Lao People's Democratic Republic",
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia (Federated States of)',
    'Moldova (the Republic of)',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine, State of',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Republic of North Macedonia',
    'Romania',
    'Russian Federation',
    'Rwanda',
    "R\xe9union",
    "Saint Barth\xe9lemy",
    'Saint Helena, Ascension and Tristan da Cunha',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin (French part)',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten (Dutch part)',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia and the South Sandwich Islands',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Sweden',
    'Switzerland',
    'Syrian Arab Republic',
    'Taiwan',
    'Tajikistan',
    'Tanzania, United Republic of',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom of Great Britain and Northern Ireland',
    'United States Minor Outlying Islands',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela (Bolivarian Republic of)',
    'Viet Nam',
    'Virgin Islands (British)',
    'Virgin Islands (U.S.)',
    'Wallis and Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
    "\xc5land Islands"
];
const countryCodeList = [
    'AF',
    'AL',
    'DZ',
    'AS',
    'AD',
    'AO',
    'AI',
    'AQ',
    'AG',
    'AR',
    'AM',
    'AW',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BY',
    'BE',
    'BZ',
    'BJ',
    'BM',
    'BT',
    'BO',
    'BQ',
    'BA',
    'BW',
    'BV',
    'BR',
    'IO',
    'BN',
    'BG',
    'BF',
    'BI',
    'CV',
    'KH',
    'CM',
    'CA',
    'KY',
    'CF',
    'TD',
    'CL',
    'CN',
    'CX',
    'CC',
    'CO',
    'KM',
    'CD',
    'CG',
    'CK',
    'CR',
    'HR',
    'CU',
    'CW',
    'CY',
    'CZ',
    'CI',
    'DK',
    'DJ',
    'DM',
    'DO',
    'EC',
    'EG',
    'SV',
    'GQ',
    'ER',
    'EE',
    'SZ',
    'ET',
    'FK',
    'FO',
    'FJ',
    'FI',
    'FR',
    'GF',
    'PF',
    'TF',
    'GA',
    'GM',
    'GE',
    'DE',
    'GH',
    'GI',
    'GR',
    'GL',
    'GD',
    'GP',
    'GU',
    'GT',
    'GG',
    'GN',
    'GW',
    'GY',
    'HT',
    'HM',
    'VA',
    'HN',
    'HK',
    'HU',
    'IS',
    'IN',
    'ID',
    'IR',
    'IQ',
    'IE',
    'IM',
    'IL',
    'IT',
    'JM',
    'JP',
    'JE',
    'JO',
    'KZ',
    'KE',
    'KI',
    'KP',
    'KR',
    'KW',
    'KG',
    'LA',
    'LV',
    'LB',
    'LS',
    'LR',
    'LY',
    'LI',
    'LT',
    'LU',
    'MO',
    'MG',
    'MW',
    'MY',
    'MV',
    'ML',
    'MT',
    'MH',
    'MQ',
    'MR',
    'MU',
    'YT',
    'MX',
    'FM',
    'MD',
    'MC',
    'MN',
    'ME',
    'MS',
    'MA',
    'MZ',
    'MM',
    'NA',
    'NR',
    'NP',
    'NL',
    'NC',
    'NZ',
    'NI',
    'NE',
    'NG',
    'NU',
    'NF',
    'MP',
    'NO',
    'OM',
    'PK',
    'PW',
    'PS',
    'PA',
    'PG',
    'PY',
    'PE',
    'PH',
    'PN',
    'PL',
    'PT',
    'PR',
    'QA',
    'MK',
    'RO',
    'RU',
    'RW',
    'RE',
    'BL',
    'SH',
    'KN',
    'LC',
    'MF',
    'PM',
    'VC',
    'WS',
    'SM',
    'ST',
    'SA',
    'SN',
    'RS',
    'SC',
    'SL',
    'SG',
    'SX',
    'SK',
    'SI',
    'SB',
    'SO',
    'ZA',
    'GS',
    'SS',
    'ES',
    'LK',
    'SD',
    'SR',
    'SJ',
    'SE',
    'CH',
    'SY',
    'TW',
    'TJ',
    'TZ',
    'TH',
    'TL',
    'TG',
    'TK',
    'TO',
    'TT',
    'TN',
    'TR',
    'TM',
    'TC',
    'TV',
    'UG',
    'UA',
    'AE',
    'GB',
    'UM',
    'US',
    'UY',
    'UZ',
    'VU',
    'VE',
    'VN',
    'VG',
    'VI',
    'WF',
    'EH',
    'YE',
    'ZM',
    'ZW',
    'AX'
];
const languages = [
    {
        name: 'Afrikaans',
        code: 'af',
        native: 'Afrikaans'
    },
    {
        name: 'Arabic',
        code: 'ar',
        native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629"
    },
    {
        name: 'Bengali',
        code: 'bn',
        native: "\u09AC\u09BE\u0982\u09B2\u09BE"
    },
    {
        name: 'Chinese',
        code: 'zh',
        native: "\u4E2D\u6587"
    },
    {
        name: 'English',
        code: 'en',
        native: 'English'
    },
    {
        name: 'Filipino',
        code: 'fil',
        native: 'Filipino'
    },
    {
        name: 'Finnish',
        code: 'fi',
        native: 'suomi'
    },
    {
        name: 'French',
        code: 'fr',
        native: "fran\xe7ais"
    },
    {
        name: 'German',
        code: 'de',
        native: 'Deutsch'
    },
    {
        name: 'Greek',
        code: 'el',
        native: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
    },
    {
        name: 'Hindi',
        code: 'hi',
        native: "\u0939\u093F\u0928\u094D\u0926\u0940"
    },
    {
        name: 'Hungarian',
        code: 'hu',
        native: 'magyar'
    },
    {
        name: 'Icelandic',
        code: 'is',
        native: "\xedslenska"
    },
    {
        name: 'Indonesian',
        code: 'id',
        native: 'Indonesia'
    },
    {
        name: 'Italian',
        code: 'it',
        native: 'italiano'
    },
    {
        name: 'Japanese',
        code: 'ja',
        native: "\u65E5\u672C\u8A9E"
    },
    {
        name: 'Korean',
        code: 'ko',
        native: "\uD55C\uAD6D\uC5B4"
    },
    {
        name: 'Polish',
        code: 'pl',
        native: 'polski'
    },
    {
        name: 'Portuguese',
        code: 'pt',
        native: "portugu\xeas"
    },
    {
        name: 'Punjabi',
        code: 'pa',
        native: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"
    },
    {
        name: 'Russian',
        code: 'ru',
        native: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        name: 'Spanish',
        code: 'es',
        native: "espa\xf1ol"
    },
    {
        name: 'Swedish',
        code: 'sv',
        native: 'svenska'
    },
    {
        name: 'Turkish',
        code: 'tr',
        native: "T\xfcrk\xe7e"
    },
    {
        name: 'Ukrainian',
        code: 'uk',
        native: "\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
    },
    {
        name: 'Vietnamese',
        code: 'vi',
        native: "Ti\u1EBFng Vi\u1EC7t"
    },
    {
        name: 'Welsh',
        code: 'cy',
        native: 'Cymraeg'
    }
];
var userInfo = {
    name: null,
    id: null,
    email: null,
    img: null,
    imgUrl: null,
    date: null,
    role: null,
    desc: null,
    lang: null,
    country: null,
    enDesc: null,
    roleLocale: null,
    un: null,
    dob: null
};
var roleInfo = {
    uid: null,
    name: null,
    role: null,
    date: null,
    desc: null,
    enDesc: null,
    roleLocale: null,
    banner: null,
    status: null,
    note: null,
    adminId: null,
    dt: null
};
const roles = [
    {
        id: 'radCeo',
        title: 'Founder & CEO',
        value: 'ceo',
        info: "Work closely with the Board of Trustees, donors, stakeholders, and the public to ensure the nonprofit's financial sustainability and fulfill its mission."
    },
    {
        id: 'radAmb',
        title: 'Ambassador',
        value: 'amb',
        info: "A representative who helps the non-profit expand its reach by using personal networks, fundraising, and volunteering to support the charity's goal."
    },
    {
        id: 'radCom',
        title: 'Director/Official of Communications',
        value: 'com',
        info: 'Build awareness and engagement through marketing and on social media.'
    },
    {
        id: 'radProg',
        title: 'Program Manager/Coordinator',
        value: 'prog',
        info: "Develop and execute program strategies and daily operations to deliver the non-profit's core mission."
    },
    {
        id: 'radFund',
        title: 'Fundraising Coordinator',
        value: 'fund',
        info: "Secure resources necessary to carry out the non-profit's mission."
    },
    {
        id: 'radVol',
        title: 'Volunteer',
        value: 'vol',
        info: 'Help charity projects by organizing or assisting at the events in support of its mission'
    }
];
const rolesEs = [
    {
        id: 'radCeo',
        title: 'Fundador y CEO',
        value: 'ceo',
        info: "Trabajar en estrecha colaboraci\xf3n con la Junta Directiva, los donantes, las partes interesadas y el p\xfablico para garantizar la sostenibilidad financiera de la organizaci\xf3n sin fines de lucro y cumplir su misi\xf3n."
    },
    {
        id: 'radAmb',
        title: 'Embajador',
        value: 'amb',
        info: "Un representante que ayuda a la organizaci\xf3n sin fines de lucro a ampliar su alcance mediante el uso de redes personales, recaudaci\xf3n de fondos y voluntariado para apoyar el objetivo de la organizaci\xf3n ben\xe9fica."
    },
    {
        id: 'radCom',
        title: 'Director/Oficial De Comunicaciones',
        value: 'com',
        info: "Genera conciencia e interacci\xf3n a trav\xe9s del marketing y las redes sociales."
    },
    {
        id: 'radProg',
        title: 'Gerente/Coordinador de programas',
        value: 'prog',
        info: "Desarrollar y ejecutar estrategias de programas y operaciones diarias para cumplir la misi\xf3n principal de la organizaci\xf3n sin fines de lucro."
    },
    {
        id: 'radFund',
        title: "Coordinador de recaudaci\xf3n de fondos",
        value: 'fund',
        info: "Obtener los recursos necesarios para llevar a cabo la misi\xf3n de la organizaci\xf3n sin fines de lucro."
    },
    {
        id: 'radVol',
        title: 'Voluntario',
        value: 'vol',
        info: "Colabora con proyectos ben\xe9ficos organizando o participando en eventos que apoyen su misi\xf3n."
    }
];
var temp_role = `<div class="role-option">
                        <input
                          type="radio"
                          id="radCeo"
                          name="select-role"
                          value="Founder & CEO"
                        />
                        <label for="radCeo">
                          <span class="role-title">Founder & CEO</span><br />
                          <span class="role-info">Oversees all</span>
                          <div class="locale" style="display: none">
                              <select name="country"></select>
                            </div>
                        </label>
                      </div>`;
function loadCountries(lang, selCountry) {
    //const selCountry = document.getElementById(elementId);
    if (!selCountry) return;
    const countries = lang != null && lang == 'es' ? countryEsList : countryList;
    const countryCode = countryCodeList;
    for(let index = 0; index < countries.length; index++){
        const name = countries[index];
        const code = countryCode[index];
        const option = document.createElement('option');
        option.value = code;
        option.textContent = name;
        selCountry.appendChild(option);
    }
    const userLocale = navigator.languages.find((lang)=>lang.includes('-')) || navigator.language;
    const locale = new Intl.Locale(userLocale);
    const region = locale.region || 'US';
    selCountry.value = region;
}
function loadLangsList(lang, selLang) {
    if (selLang == null) return;
    const langs = languages;
    selLang.innerHTML = '';
    langs.forEach((langObj)=>{
        const option = document.createElement('option');
        option.value = langObj.code;
        option.textContent = langObj.native;
        selLang.appendChild(option);
    });
    let targetLang = 'en';
    if (lang && lang !== 'en') targetLang = lang;
    else {
        const rawLang = navigator.language || navigator.userLanguage;
        targetLang = rawLang.split('-')[0].toLowerCase();
    }
    selLang.value = targetLang;
}
function loadLangList(lang, selLang) {
    if (selLang == null) return;
    const langs = languages;
    langs.forEach((lang)=>{
        const option = document.createElement('option');
        option.value = lang.code;
        option.textContent = lang.native;
        selLang.appendChild(option);
    });
    if (lang != null && lang != 'en') selLang.value = lang;
    else {
        const langCode = navigator.language.split('-')[0];
        console.log('browser lang = ' + langCode);
        selLang.value = langCode || 'en';
        console.log('comoon selected lang = ' + selLang.value);
    }
}
function getCountryName(code, lang) {
    const countries = lang != null && lang == 'es' ? countryEsList : countryList;
    const countryCode = countryCodeList;
    const index = countryCode.indexOf(code);
    return index !== -1 ? countries[index] : '';
}
function getLanguageName(code) {
    const langObj = languages.find((lang)=>lang.code === code);
    return langObj ? langObj.native : '';
}
function validateEmail(input) {
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return reg.test(input);
}
function validateName(name) {
    // Regex pattern allows letters (a-z, A-Z), spaces, hyphens, and apostrophes
    // The pattern also ensures the name is not empty or just special characters
    var namePattern = /^[a-zA-Z\s-']+$/;
    if (!name || name.trim() === '') return false;
    if (!namePattern.test(name)) return false;
    return true;
}
var temp_popLoading = `<div id="popLoading" class="popOverlay no-print">
      <div class="content">
        <h3>${getCookie(cookieFbLang) == 'es' ? 'Por favor espera...' : 'Please wait...'}</h3>

        <div class="popInfo v-center">
          <p class="popMsg">${getCookie(cookieFbLang) == 'es' ? 'Procesando tu solicitud...' : 'Processing your request...'}</p>
          <iframe src="https://lottie.host/embed/17bd15e1-c9a2-4c06-b9db-4c238402ba83/zg58YIYAQH.lottie"></iframe>
        </div>
      </div>
    </div>`;
function addLoadingPopup(parent, show, msg) {
    var div = document.createElement('div');
    div.innerHTML = temp_popLoading;
    if (parent) parent.appendChild(div.firstChild);
    else document.body.appendChild(div.firstChild);
    if (msg) {
        var popMsg = document.querySelector('#popLoading .popMsg');
        popMsg.textContent = msg;
    }
    if (show) showLoadingPopup(msg);
}
function togglePopLoading(show, msg, top, parent) {
    let popLoading = document.getElementById('popLoading');
    if (popLoading == null) {
        if (popLoading == null) {
            addLoadingPopup(parent || document.getElementById('main'), false);
            popLoading = document.getElementById('popLoading');
        }
    }
    if (top) popLoading.style.alignItems = 'flex-start';
    if (msg) {
        var popMsg = popLoading.querySelector('.popMsg');
        popMsg.textContent = msg;
    }
    popLoading.style.display = show ? 'flex' : 'none';
}
function showLoadingPopup(msg) {
    var popup = document.getElementById('popLoading');
    if (!popup) return;
    if (msg) {
        var popMsg = popup.querySelector('.popMsg');
        popMsg.textContent = msg;
    }
    popup.style.display = 'flex';
}
function setInputError(inputElement, isError, errorMsg, lang) {
    if (isError) {
        inputElement.setCustomValidity(errorMsg ? errorMsg : lang != null && lang == 'es' ? "Informaci\xf3n invalida" : 'Invalid input');
        inputElement.focus();
    } else inputElement.setCustomValidity('');
}
function setInputValidity(inputElement, isError, errorMsg) {
    // Find or create an error element container next to the input
    let errorSpan = inputElement.parentNode.querySelector('.dynamic-error-msg');
    if (isError) {
        if (!errorSpan) {
            errorSpan = document.createElement('span');
            errorSpan.className = 'dynamic-error-msg';
            // Style it using standard inline rules or an external CSS class
            // errorSpan.style.color = 'red';
            // errorSpan.style.fontSize = '0.85rem';
            // errorSpan.style.display = 'block';
            // errorSpan.style.marginTop = '4px';
            // Safely insert it right after the input field in the DOM tree
            inputElement.parentNode.insertBefore(errorSpan, inputElement.previousSibling);
        }
        const defaultMsg = 'Invalid input';
        errorSpan.textContent = errorMsg ? errorMsg : defaultMsg;
        inputElement.classList.add('input-error-border');
    } else {
        // If no error, cleanly strip the generated element and classes out of the DOM
        if (errorSpan) errorSpan.remove();
        inputElement.classList.remove('input-error-border');
    }
}
function getLoginError(code, lang) {
    let isEs = lang == 'es';
    switch(code){
        case 'auth/invalid-email':
            return isEs ? 'El correo no es valido' : 'The email is not valid';
        case 'auth/user-disabled':
            return isEs ? 'La cuenta no esta activa' : 'The account is not active';
        case 'auth/user-not-found':
            return isEs ? 'La cuenta no existe' : 'The account does not exist';
        case 'auth/network-request-failed':
            return isEs ? "No se pudo conectar a la red. Int\xe9ntalo de nuevo m\xe1s tarde." : 'Could not connect to the network. Try again later';
        case 'auth/too-many-requests':
            return isEs ? "Demasiados intentos fallidos de inicio de sesi\xf3n. Int\xe9ntalo de nuevo m\xe1s tarde." : 'Too many failed login attempts. Try again later.';
        default:
            return isEs ? "Correo electr\xf3nico o contrase\xf1a incorrectos" : 'Incorrect email or password';
    }
}
function getRegisterError(code, lang) {
    let isEs = lang == 'es';
    switch(code){
        case 'auth/invalid-email':
            return isEs ? 'El correo no es valido' : 'The email is not valid';
        case 'auth/email-already-in-use':
            return isEs ? "La cuenta ya existe con este correo. Inicia sesi\xf3n en su lugar." : 'An account with this email already exists. Login instead.';
        case 'auth/weak-password':
            return isEs ? "La contrase\xf1a es muy d\xe9bil." : 'The password is too weak.';
        case 'auth/network-request-failed':
            return isEs ? "No se pudo conectar a la red. Int\xe9ntalo de nuevo m\xe1s tarde." : 'Could not connect to the network. Try again later';
        case 'auth/too-many-requests':
            return isEs ? "Demasiados intentos fallidos. Int\xe9ntalo de nuevo m\xe1s tarde." : 'Too many failed attempts. Try again later.';
        default:
            return isEs ? "No se pudo crear la cuenta. Intenta de nuevo m\xe1s tarde." : 'Could not create account. Try again later.';
    }
}
function validatePassword(pw) {
    return pw.length >= 8;
}
let popConfirm = `<div id="popConfirmOverlay" class="popOverlay no-print">
      <div class="content">
        <h3>Name</h3>
       <p class="pop-msg"></p>
        <div class="h-flex h-even-space">
          <button class="btn-no btn-u-red">No</button>
          <button class="btn-yes btn-green">Yes</button>
        </div>
      </div>
    </div>`;
function togglePopConfirm(lang, title, msg, btnYesMsg, btnNoMsg, action) {
    var popup = document.getElementById('popConfirmOverlay');
    if (!popup) {
        var div = document.createElement('div');
        div.innerHTML = popConfirm;
        document.body.appendChild(div.firstChild);
        popup = div.firstChild;
        var btnClose = popup.querySelector('.btn-no');
        btnClose.addEventListener('click', function() {
            popup.style.display = 'none';
        });
    }
    var popTitle = popup.querySelector('h3');
    var dMsg = popup.querySelector('.pop-msg');
    var btnYes = popup.querySelector('.btn-yes');
    var btnNo = popup.querySelector('.btn-no');
    btnYes.textContent = btnYesMsg || (lang == 'es' ? "S\xed" : 'Yes');
    btnNo.textContent = btnNoMsg || (lang == 'es' ? 'No' : 'No');
    popTitle.textContent = title;
    dMsg.textContent = msg;
    btnYes.addEventListener('click', function() {
        action();
        popup.style.display = 'none';
    });
    popup.style.display = 'flex';
}
let popMsg = `<div id="popUpOverlay">
      <div class="content">
        <h3>Name</h3>
       <p class="pop-msg"></p>
        <div class="h-flex h-even-space">
          <a href="portal.html" class="btn-no-deco-blue">Go to Portal</a>
          <button class="btn-green">Ok</button>
        </div>
      </div>
    </div>`;
function togglePopMsg(title, msg, isShow, top, link, action) {
    var popup = document.getElementById('popUpOverlay');
    if (!popup) {
        var div = document.createElement('div');
        div.innerHTML = popMsg;
        document.body.appendChild(div.firstChild);
        popup = document.getElementById('popUpOverlay');
        var btnClose = popup.querySelector('.btn-green');
        btnClose.addEventListener('click', function() {
            if (action) action();
            else popup.style.display = 'none';
        });
    }
    if (top) popup.style.alignItems = 'flex-start';
    var popTitle = popup.querySelector('h3');
    var dMsg = popup.querySelector('.pop-msg');
    var aLink = popup.querySelector('a');
    if (link) {
        aLink.href = link;
        aLink.style.display = 'block';
    } else aLink.style.display = 'none';
    popTitle.textContent = title;
    dMsg.textContent = msg;
    popup.style.display = isShow ? 'flex' : 'none';
}
function createUser(user, email, id, username) {
    if (user == null) return null;
    return {
        name: user.name,
        id: id ? id : user.id,
        email: email,
        img: user.img,
        imgUrl: user.imgUrl,
        date: user.date,
        role: user.role,
        desc: user.desc,
        lang: user.lang,
        country: user.country,
        enDesc: user.enDesc,
        roleLocale: user.roleLocale,
        un: user.un || username,
        dob: user.dob
    };
}
function createEmptyUser() {
    return structuredClone(userInfo);
}
function createEmptyRole() {
    return structuredClone(roleInfo);
}
var temp_loginPrompt = `<div id="loginRequest">
          <div id="dProgress" class="content">
            <p>${getCookie(cookieFbLang) == 'es' ? 'Preparando solicitud...' : 'Preparing application...'}</p>
            <iframe
              src="https://lottie.host/embed/17bd15e1-c9a2-4c06-b9db-4c238402ba83/zg58YIYAQH.lottie"
            ></iframe>
          </div>
          <div id="dLogin" class="content v-flex">
            <p>${getCookie(cookieFbLang) == 'es' ? "Inicia sesi\xf3n o reg\xedstrate para ver tu cuenta" : 'Login or register to view your account'}</p>
            <button id="btnLogin" class="btn-blue">${getCookie(cookieFbLang) == 'es' ? "Iniciar sesi\xf3n" : 'Login'}</button>
            <p class="light-text">
              <span>----------</span>${getCookie(cookieFbLang) == 'es' ? 'O' : 'Or'}<span>----------</span>
            </p>
            <button id="btnRegister" class="btn-u-blue">${getCookie(cookieFbLang) == 'es' ? 'Registrarme' : 'Register'}</button>
          </div>
        </div>`;
var temp_loginForm = `<div id="inLogin" class="popOverlay">
        <div class="content h-90 w-80">
          <button class="btn-close-right">${getCookie(cookieFbLang) == 'es' ? 'Cerrar' : 'Close'}</button>
          <iframe
            src="login.html"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>`;
function toggleLoginForm(show) {
    let inLogin = document.getElementById('inLogin');
    if (inLogin == null) return;
    inLogin.style.display = show ? 'flex' : 'none';
}
function toggleLoginPrompt(from, showPop, showLogin, showLoader, getUser = true) {
    var loginRequest = document.getElementById('loginRequest');
    if (loginRequest == null) {
        const lang = getCookie(cookieFbLang) || 'en';
        var div = document.createElement('div');
        div.innerHTML = temp_loginPrompt;
        document.body.appendChild(div.firstChild);
        loginRequest = document.getElementById('loginRequest');
        let inLogin = document.getElementById('inLogin');
        if (inLogin == null) {
            var div = document.createElement('div');
            div.innerHTML = temp_loginForm;
            document.body.appendChild(div.firstChild);
            inLogin = document.getElementById('inLogin');
            let btnClose = inLogin.querySelector('.btn-close-right');
            if (lang == 'es') btnClose.textContent = 'Cerrar';
            btnClose.addEventListener('click', function() {
                inLogin.style.display = 'none';
                loginRequest.style.display = 'flex';
            });
        }
        const btnLogin = document.getElementById('btnLogin');
        btnLogin.addEventListener('click', function() {
            loginRequest.style.display = 'none';
            inLogin.querySelector('iframe').src = `/login.html?from=${from}&action=login&getUser=${getUser}`;
            inLogin.style.display = 'flex';
        });
        const btnRegister = document.getElementById('btnRegister');
        btnRegister.addEventListener('click', function() {
            loginRequest.style.display = 'none';
            inLogin.querySelector('iframe').src = `/login.html?from=${from}&action=register&getUser=${getUser}`;
            inLogin.style.display = 'flex';
        });
    }
    loginRequest.style.display = showPop ? 'flex' : 'none';
    loginRequest.querySelector('#dLogin').style.display = showLogin ? 'block' : 'none';
    loginRequest.querySelector('#dProgress').style.display = showLoader ? 'block' : 'none';
}
let check = `<i class="fa-solid fa-circle-check" style="color: #117453;"></i>`;
let warn = `<i class="fa-solid fa-triangle-exclamation" style="color: #ff9f1a;"></i>`;
let error = `<i class="fa-solid fa-circle-exclamation" style="color: #ad0000;"></i>`;
let info = `<i class="fa-solid fa-circle-info" style="color: #065ff9;"></i>`;
let elToast = `<div id="toast" class="success">
<div class="h-flex center-items">
  <span
    ><i class="fa-solid fa-circle-check" style="color: #117453"></i
  ></span>
  <p class="ml-8">Success!</p>
</div>
</div>`;
function showToast(type, msg, time) {
    let toast = document.getElementById('toast');
    let spImg, pMsg;
    if (!toast) {
        const container = document.createElement('div');
        container.innerHTML = elToast;
        toast = container.firstChild;
        document.body.appendChild(toast);
    }
    spImg = toast.querySelector('span');
    pMsg = toast.querySelector('p');
    toast.className = type;
    switch(type){
        case 'warn':
            spImg.innerHTML = warn;
            break;
        case 'error':
            spImg.innerHTML = error;
            break;
        case 'info':
            spImg.innerHTML = info;
            break;
        case 'success':
        default:
            spImg.innerHTML = check;
            break;
    }
    pMsg.textContent = msg;
    toast.classList.add('show');
    console.log('will toast');
    // After 3 seconds, remove the show class from toast
    setTimeout(function() {
        toast.classList.remove('show');
    }, time ? time : 3000);
}
const msgLoader = `<div id="loadingOverlay" class="loading-overlay" aria-live="assertive" role="alert">
  <div class="loader-container">
    <div class="spinner"></div>
    <p id="loadingMessage" class="loading-text">Loading, please wait...</p>
  </div>
</div>`;
function showMsgLoader(msg = (0, _translator.i18n).t('msg_loading')) {
    let loadingOverlay = document.getElementById('loadingOverlay');
    if (!loadingOverlay) {
        const container = document.createElement('div');
        container.innerHTML = msgLoader;
        loadingOverlay = container.firstChild;
        document.body.appendChild(loadingOverlay);
    }
    const loadingMessage = loadingOverlay.querySelector('#loadingMessage');
    loadingMessage.textContent = msg;
    loadingOverlay.classList.add('active');
}
function updateMsgLoader(msg = (0, _translator.i18n).t('msg_loading')) {
    let loadingOverlay = document.getElementById('loadingOverlay');
    if (loadingOverlay) {
        const loadingMessage = loadingOverlay.querySelector('#loadingMessage');
        loadingMessage.textContent = msg;
    }
}
function hideMsgLoader() {
    let loadingOverlay = document.getElementById('loadingOverlay');
    console.log('loading overlay: ', loadingOverlay);
    if (loadingOverlay) loadingOverlay.classList.remove('active');
}
const temp_campaignCard = `<div class="campaign-card">
              <img
                class="campaign-image exam"
                src="images/pexel/medical.jpg"
                alt="Medical Aid"
              />
              <div class="campaign-overlay">
                <h3 class="campaign-title" data-i18n="medical_aid">
                  Medical Aid
                </h3>
                <a
                  class="campaign-btn"
                  href="user/camp1"
                  data-i18n="view_impact"
                  >View Impact</a
                >
              </div>
            </div>`;
function createCampaignCard() {
    const container = document.createElement('div');
    container.innerHTML = temp_campaignCard;
    return container.firstChild;
}
const temp_videoItem = `<div class="gallery-item">
                <video class="media-src" src="videos/tiktok.mp4"></video>
                <div title="Play video" aria-label="Play video" data-i18n-attr='{"aria-label":"play_video","title":"play_video"}' class="video-play-icon">\u{25B6}</div>
              </div>`;
const temp_imgItem = `<div class="gallery-item">
                <img class="media-src" src="images/parents.png" alt="" />
                <div class="gallery-overlay">
                  <span data-i18n="view_preview">View Image</span>
                </div>
              </div>`;
function createMediaItem(type = 'image') {
    const container = document.createElement('div');
    if (type === 'video') container.innerHTML = temp_videoItem;
    else container.innerHTML = temp_imgItem;
    (0, _translator.i18n).translatePage(container);
    return container.firstChild;
}
const temp_imgWrapper = `<div class="gallery-item">
                          <img
                            src="images/svg/ph-img.svg"
                            alt="Gallery image"
                            data-i18n-attr='{"alt":"gallery_image"}'
                          />
                          <div class="gallery-overlay-mock">
                            <i
                              class="fa-solid fa-arrow-left cancel"
                              style="color: rgb(202, 202, 202)"
                              aria-label="Go back"
                              title="Go back"
                              data-i18n-attr='{"aria-label":"go_back","title":"go_back"}'
                            ></i>
                            <i
                              class="fa-solid fa-trash-can remove"
                              aria-label="Delete image"
                              title="Delete image"
                              data-i18n-attr='{"aria-label":"delete_image","title":"delete_image"}'
                            ></i>
                          </div>
                        </div>`;
function createImgWrapper() {
    const container = document.createElement('div');
    container.innerHTML = temp_imgWrapper;
    return container.firstChild;
}
const temp_fileItem = `<div class="receipt-item">
                    <i class="fa-solid fa-check-double uploaded-icon"></i>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener"
                      class="receipt-title"
                      >Receipt title</a
                    >
                    <button
                      class="btn-icon-delete"
                      aria-label="Delete file"
                      title="Delete file"
                      data-i18n-attr='{"aria-label":"delete_file", "title":"delete_file"}'
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>`;
function createFileItem() {
    const container = document.createElement('div');
    container.innerHTML = temp_fileItem;
    return container.firstChild;
}
function getFileNameFromUrl(url) {
    // Extract path between /o/ and the query parameters (?)
    const filePath = url.split('/o/')[1].split('?')[0];
    // Decode the URL-encoded characters (like %2F to /)
    const decodedPath = decodeURIComponent(filePath);
    // Get the final item in the path array
    return decodedPath.split('/').pop();
}
let temp_inputEdit = `<div id="inputEdit" class="popOverlay" style="display: flex">
        <div class="content w-50">
          <p class="bold green-txt" id="pTitle">Title</p>
          <p id="pMsg" class="sm-txt">Message</p>
          <input type="text" id="inEdit" placeholder="Name" />

          <div class="res-h-flex h-even-space margin-10 mt-48">
            <button class="btn-no-deco-gray btn-no">Cancel</button>
            <button class="btn-green btn-yes">Save changes</button>
          </div>
        </div>
      </div>`;
function showInputEdit(lang, title, msg, inputType, defaultVal, placeholder, onSave) {
    let inputEdit = document.getElementById('inputEdit');
    if (!inputEdit) {
        const container = document.createElement('div');
        container.innerHTML = temp_inputEdit;
        inputEdit = container.firstChild;
        document.body.appendChild(inputEdit);
    }
    let pTitle = inputEdit.querySelector('#pTitle');
    let pMsg = inputEdit.querySelector('#pMsg');
    let inEdit = inputEdit.querySelector('#inEdit');
    let btnNo = inputEdit.querySelector('.btn-no');
    let btnYes = inputEdit.querySelector('.btn-yes');
    inEdit.type = inputType ? inputType : 'text';
    inEdit.focus();
    pTitle.textContent = title;
    pMsg.textContent = msg;
    inEdit.value = defaultVal ? defaultVal : '';
    inEdit.placeholder = placeholder ? placeholder : '';
    btnYes.onclick = function() {
        if (onSave) {
            let val = inEdit.value.trim();
            if (val == '') {
                showToast('warn', lang == 'es' ? "El campo no puede estar vac\xedo" : 'Input cannot be empty');
                inEdit.focus();
                return;
            } else if (val == defaultVal) {
                showToast('warn', lang == 'es' ? 'El valor no ha cambiado' : 'Value has not changed');
                inEdit.focus();
                return;
            }
            onSave(val);
        }
        inputEdit.style.display = 'none';
    };
    btnNo.onclick = function() {
        inputEdit.style.display = 'none';
    };
}
const campaignPrograms = [
    {
        title: 'Health Care',
        val: 'health',
        i18n: 'health_care'
    },
    {
        title: 'Education & Literacy',
        val: 'education',
        i18n: 'education_literacy'
    },
    {
        title: 'Hunger Relief',
        val: 'meals',
        i18n: 'hunger_relief'
    },
    {
        title: 'Disaster Relief',
        val: 'disaster',
        i18n: 'disaster_relief'
    },
    {
        title: 'Animal Welfare',
        val: 'animal',
        i18n: 'animal_welfare'
    }
];
function loadCampaignPrograms(selCampaign) {
    if (selCampaign == null) return;
    campaignPrograms.forEach((program)=>{
        const option = document.createElement('option');
        option.value = program.val;
        option.textContent = program.title;
        option.setAttribute('data-i18n', program.i18n);
        selCampaign.appendChild(option);
    });
}
const programs = [
    {
        title: 'Disaster relief',
        type: 'Disaster',
        val: 'disaster'
    },
    {
        title: 'Financial Medical Aid',
        type: 'Medical',
        val: 'medical'
    },
    {
        title: 'Utilities Assistance',
        type: 'Utilities',
        val: 'utilities'
    },
    {
        title: 'Student Aid',
        type: 'Student',
        val: 'student'
    }
];
const programsEs = [
    {
        title: 'Ayuda En Caso De Desastre',
        type: 'Desastre',
        val: 'disaster'
    },
    {
        title: "Ayuda m\xe9dica financiera",
        type: "M\xe9dica",
        val: 'medical'
    },
    {
        title: "Asistencia con los servicios p\xfablicos",
        type: "Servicios p\xfablicos",
        val: 'utilities'
    },
    {
        title: 'Ayuda Para Estudiantes',
        type: 'Estudiante',
        val: 'student'
    }
];
const status = [
    {
        title: 'Pending',
        value: 'pending'
    },
    {
        title: 'Incomplete',
        value: 'incomplete'
    },
    {
        title: 'Approved - Waiting for Payment',
        value: 'approved'
    },
    {
        title: 'Denied',
        value: 'denied'
    },
    {
        title: 'Completed',
        value: 'completed'
    }
];
const statusEs = [
    {
        title: 'Pendiente',
        value: 'pending'
    },
    {
        title: 'Incompleto',
        value: 'incomplete'
    },
    {
        title: 'Aprovado - Esperando Pago',
        value: 'approved'
    },
    {
        title: 'Denegado',
        value: 'denied'
    },
    {
        title: 'Completado',
        value: 'completed'
    }
];
function initPrograms(lang, selProgram) {
    if (selProgram == null) return;
    const programList = lang == 'es' ? programsEs : programs;
    programList.forEach((program)=>{
        const option = document.createElement('option');
        option.value = program.val;
        option.textContent = program.title;
        selProgram.appendChild(option);
    });
}
function initStatusOptions(lang, selStatus) {
    const statusList = lang == 'es' ? statusEs : status;
    statusList.forEach((status)=>{
        const option = document.createElement('option');
        option.value = status.value;
        option.textContent = status.title;
        selStatus.appendChild(option);
    });
}
let temp_fileUpload = `<div class="file">
                    <span class="file-name sm-font">Name</span>
                    <button class="remove btn-no-deco-gray">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>`;
function validateDOB(dateString) {
    const dob = new Date(dateString);
    const today = new Date();
    // 1. Valid date check
    if (isNaN(dob.getTime())) return false;
    // 2. Not in the future
    if (dob > today) return false;
    // 3. Realistic age range (e.g., max 120 years old)
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 120);
    if (dob < minDate) return false;
    return true;
}
function formatMoney(value) {
    if (value) return parseFloat(value).toFixed(2);
    else return null;
}
function validatePhone(phone) {
    const pattern = /^[0-9\-]{6,12}$/; ///^(?!-+$)[0-9-]+$/;
    return pattern.test(phone);
}
var donee = {
    date: null,
    uid: null,
    staffId: null
};
function newDonee() {
    return structuredClone(donee);
}
var denied = {
    date: null,
    uid: null,
    staffId: null
};
function newDenied() {
    return structuredClone(denied);
}
var simpleHelp = {
    date: null,
    uid: null,
    staffId: null
};
function newSimpleHelp() {
    return structuredClone(simpleHelp);
}
var donation = {
    date: null,
    amount: null,
    uid: null,
    staffId: null
};
function newDonation() {
    return structuredClone(donation);
}
var helpForm = {
    date: null,
    name: null,
    contact: null,
    address: null,
    program: null,
    phone: null,
    text: null,
    call: null,
    email: null,
    employment: null,
    houseSize: null,
    income: null,
    expenses: null,
    requestAmount: null,
    repairCost: null,
    insuranceName: null,
    policyNum: null,
    insurancePhone: null,
    desc: null,
    signDate: null,
    signature: null,
    medBill: null,
    hospitalName: null,
    hospitalAddress: null,
    schoolName: null,
    schoolAddress: null,
    schoolPhone: null,
    status: 'pending',
    note: null,
    uid: null,
    dob: null,
    key: null,
    staffId: null,
    staffName: null,
    staffDate: null,
    approvedDate: null,
    approvedAmount: null,
    payType: null,
    payDate: null
};
function newHelpForm() {
    return structuredClone(helpForm);
}
function copyHelpForm(form, staffId, staffName) {
    if (form == null) return null;
    return {
        date: form.date,
        name: form.name,
        contact: form.contact,
        address: form.address,
        program: form.program,
        phone: form.phone,
        text: form.text,
        call: form.call,
        email: form.email,
        employment: form.employment,
        houseSize: form.houseSize,
        income: form.income,
        expenses: form.expenses,
        requestAmount: form.requestAmount,
        repairCost: form.repairCost,
        insuranceName: form.insuranceName,
        policyNum: form.policyNum,
        insurancePhone: form.insurancePhone,
        desc: form.desc,
        signDate: form.signDate,
        signature: form.signature,
        medBill: form.medBill,
        hospitalName: form.hospitalName,
        hospitalAddress: form.hospitalAddress,
        schoolName: form.schoolName,
        schoolAddress: form.schoolAddress,
        schoolPhone: form.schoolPhone,
        status: form.status || 'pending',
        note: form.note,
        uid: form.uid,
        dob: form.dob,
        key: form.key,
        staffId: form.staffId ? `${form.staffId}, ${staffId}` : staffId,
        staffName: form.staffName ? `${form.staffName}, ${staffName}` : staffName,
        staffDate: form.staffDate,
        approvedAmount: form.approvedAmount,
        payType: form.payType
    };
}
function formatInputDate(time) {
    let date = time ? new Date(time) : new Date();
    const year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
function formatDisplayDate(time) {
    let date = time ? new Date(time) : new Date();
    const year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
}
function formatDisplayTime(time) {
    let date = time ? new Date(time) : new Date();
    let hours = date.getHours().toString().padStart(2, '0');
    let hr = (hours % 12 || 12).toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hr}:${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
}
var temp_helpFormLog = `<td>
                    <div class="program-type">Program Name</div>
                  </td>
                  <td class="date">00/00/0000</td>
                  <td class="status">Pending</td>
                  <td class="actions">
                    <button class="btn-view">
                      <span>View</span><i class="fa-solid fa-eye"></i>
                    </button>
                  </td>`;
function createHelpFormLog(formId, form, lang, action) {
    const parent = document.createElement('tr');
    parent.style.textAlign = 'center';
    parent.innerHTML = temp_helpFormLog;
    parent.querySelector('.program-type').textContent = lang == 'es' ? programsEs.find((p)=>p.val == form.program)?.title || form.program : programs.find((p)=>p.val == form.program)?.title || form.program;
    parent.querySelector('.date').textContent = form.date ? formatDisplayDate(form.date) : '';
    parent.querySelector('.status').textContent = lang == 'es' ? statusEs.find((s)=>s.value == form.status)?.title || form.status : status.find((s)=>s.value == form.status)?.title || form.status;
    const btnView = parent.querySelector('.btn-view');
    btnView.querySelector('span').textContent = lang == 'es' ? 'Ver' : 'View';
    btnView.onclick = function() {
        action(formId, form);
    };
    parent.id = formId;
    return parent;
}
var temp_helpFormFile = `<td class="file-name">File Name</td>
                        <td class="file-type">PDF</td>
                        <td class="file-size">1.2 MB</td>
                        <td class="date sm-font">00:00 00/00/0000</td>
                        <td class="actions">
                          <div class="v-flex no-print">
                            <button class="btn-view btn-u-white btn-icon mb-10">
                              <i class="fa-solid fa-eye"></i><span>View</span>
                            </button>
                            <button class="btn-delete btn-u-white btn-icon">
                              <i class="fa-solid fa-trash"></i
                              ><span>Delete</span>
                            </button>
                          </div>
                        </td>`;
function createHelpFormFile(lang, fileInfo, fileId, viewAction, deleteAction) {
    const parent = document.createElement('tr');
    parent.style.textAlign = 'center';
    parent.innerHTML = temp_helpFormFile;
    parent.querySelector('.file-name').textContent = fileInfo.name || (lang == 'es' ? 'Archivo sin nombre' : 'Unnamed file');
    parent.querySelector('.file-type').textContent = fileInfo.type || (lang == 'es' ? 'Desconocido' : 'Unknown');
    parent.querySelector('.file-size').textContent = fileInfo.size ? formatBytes(fileInfo.size) : '--';
    parent.querySelector('.date').textContent = fileInfo.date ? `${formatDisplayTime(fileInfo.date)} ${formatDisplayDate(fileInfo.date)}` : '';
    const btnView = parent.querySelector('.btn-view');
    btnView.querySelector('span').textContent = lang == 'es' ? 'Ver' : 'View';
    btnView.onclick = function() {
        viewAction(fileId, fileInfo);
    };
    const btnDelete = parent.querySelector('.btn-delete');
    btnDelete.querySelector('span').textContent = lang == 'es' ? 'Eliminar' : 'Delete';
    btnDelete.onclick = function() {
        deleteAction(fileId, fileInfo);
    };
    parent.id = `file-${fileId}`;
    return parent;
}
function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    // Calculate the index of the unit to use
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    // Calculate the value and fix the decimal points
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
var temp_listItem = `<div class="h-flex round-white pad-10 mb-20">
                <img
                  src="images/svg/ph-user.svg"
                  alt="User profile image"
                  class="pointer user-img-top"
                />
                <div class="v-flex ml-20 w-100 pointer">
                  <div class="h-flex">
                    <div class="name bold fill">John Doe</div>
                    <div class="time font-small mr-10">12:00 PM</div>
                    <div class="date font-small">00/00/0000</div>
                  </div>
                  <div class="info">Program Name</div>
                </div>
                <span class="self-center pointer"
                  ><i class="fa-solid fa-angle-right"></i
                ></span>
              </div>`;
function createAssistItem(assist, helpUid, helpKey, imgUrl, lang, action) {
    const container = document.createElement('div');
    container.innerHTML = temp_listItem;
    const item = container.firstChild;
    item.id = `${helpUid}-${helpKey}`;
    //add erro listener to img
    console.log('img: ', imgUrl);
    if (imgUrl != null && imgUrl == -1) item.querySelector('img').style.display = 'none';
    else {
        item.querySelector('img').addEventListener('error', function(event) {
            event.target.src = phUser;
        });
        item.querySelector('img').src = imgUrl || phUser;
    }
    item.querySelector('.name').textContent = assist.name;
    item.querySelector('.info').textContent = lang == 'es' ? programsEs.find((p)=>p.val == assist.program)?.title || assist.program : programs.find((p)=>p.val == assist.program)?.title || assist.program;
    item.querySelector('.time').textContent = formatDisplayTime(assist.date);
    item.querySelector('.date').textContent = formatDisplayDate(assist.date);
    item.onclick = function() {
        if (action) action(helpKey, helpUid, assist);
    };
    return item;
}
function createHireItem(hireInfo, hireKey, hireUid, imgUrl, action, lang) {
    const container = document.createElement('div');
    container.innerHTML = temp_listItem;
    const item = container.firstChild;
    item.id = `${hireUid}-${hireKey}`;
    item.querySelector('img').addEventListener('error', function(event) {
        event.target.src = phUser;
    });
    item.querySelector('img').src = imgUrl || phUser;
    item.querySelector('.name').textContent = hireInfo.name;
    item.querySelector('.info').textContent = lang == 'es' ? rolesEs.find((r)=>r.value == hireInfo.role)?.title || hireInfo.role : roles.find((r)=>r.value == hireInfo.role)?.title || hireInfo.role;
    item.querySelector('.time').textContent = formatDisplayTime(hireInfo.date);
    item.querySelector('.date').textContent = formatDisplayDate(hireInfo.date);
    item.onclick = function() {
        action(hireInfo, hireUid);
    };
    return item;
}
const temp_linkShare = `<div class="modal-overlay" id="modalOverlay">
        <div class="share-modal">
            <div class="modal-header">
                <h3 data-i18n="share">Share</h3>
                <button class="close-btn" id="closeShare">&times;</button>
            </div>

            <!-- Social Media Grid -->
            <div class="social-networks">
                <a href="#" target="_blank" class="social-btn" id="shareFB">
                    <div class="icon-wrapper facebook">FB</div>
                    Facebook
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareX">
                    <div class="icon-wrapper x-twitter">X</div>
                    X / Twitter
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareLI">
                    <div class="icon-wrapper linkedin">In</div>
                    LinkedIn
                </a>
                <a href="#" target="_blank" class="social-btn" id="shareWA">
                    <div class="icon-wrapper whatsapp">WA</div>
                    WhatsApp
                </a>
            </div>

            <!-- Copy Link Bar -->
            <div class="copy-link-section">
                <input type="text" class="link-input" id="shareUrlInput" readonly>
                <button class="copy-btn" id="copyLinkBtn" data-i18n="copy">Copy</button>
            </div>
        </div>
    </div>`;
function showShareModal(show, url, shareText = (0, _translator.i18n).t('share_text')) {
    let modalOverlay = document.getElementById('modalOverlay');
    if (!show) {
        if (modalOverlay) modalOverlay.style.display = 'none';
        return;
    }
    if (!modalOverlay) {
        const container = document.createElement('div');
        container.innerHTML = temp_linkShare;
        modalOverlay = container.firstChild;
        document.body.appendChild(modalOverlay);
    }
    const h3 = modalOverlay.querySelector('h3');
    h3.textContent = (0, _translator.i18n).t('share');
    const shareUrlInput = document.getElementById('shareUrlInput');
    shareUrlInput.value = url;
    const closeModal = ()=>{
        modalOverlay.classList.remove('active');
    };
    const closeShare = document.getElementById('closeShare');
    closeShare.onclick = function() {
        closeModal();
    };
    const copyLinkBtn = document.getElementById('copyLinkBtn');
    copyLinkBtn.textContent = (0, _translator.i18n).t('copy');
    copyLinkBtn.onclick = async function() {
        try {
            await navigator.clipboard.writeText(url);
            // Visual confirmation handling
            copyLinkBtn.textContent = 'Copied!';
            copyLinkBtn.classList.add('copied');
            // Revert state after a delayed duration
            setTimeout(()=>{
                copyLinkBtn.textContent = 'Copy';
                copyLinkBtn.classList.remove('copied');
            }, 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };
    const shareFB = document.getElementById('shareFB');
    shareFB.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    const shareX = document.getElementById('shareX');
    shareX.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareText)}`;
    const shareLI = document.getElementById('shareLI');
    shareLI.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    const shareWA = document.getElementById('shareWA');
    shareWA.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + ' ' + url)}`;
    modalOverlay.addEventListener('click', (e)=>{
        if (e.target === modalOverlay) closeModal();
    });
    modalOverlay.classList.add('active');
}
const temp_campaignCreated = `<div class="modal-overlay" id="campaignCreatedOverlay">
  <div class="campaign-created-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h3 data-i18n="campaign_submitted">Campaign Submitted</h3>
        <button class="close-btn" id="closeCampaignCreated">&times;</button>
      </div>
      <p data-i18n="campaign_submitted_msg">Your campaign has been successfully created!</p>
      <p data-i18n="campaign_pending_msg">Your campaign is pending approval.</p>
      <div class="modal-actions">
        <button class="btn-blue" id="okCampaignCreated" data-i18n="ok">OK</button>
      </div>
    </div>
  </div>
</div>
`;
function showCampaignCreatedModal(show, onOk) {
    let modalOverlay = document.getElementById('campaignCreatedOverlay');
    if (!show) {
        if (modalOverlay) modalOverlay.classList.remove('active');
        return;
    }
    // 1. Create the modal if it doesn't exist
    if (!modalOverlay) {
        const container = document.createElement('div');
        container.innerHTML = temp_campaignCreated.trim(); // .trim() safely prevents whitespace bugs
        modalOverlay = container.firstElementChild;
        document.body.appendChild(modalOverlay);
        // Static event listener (this one never needs to change)
        const closeBtn = modalOverlay.querySelector('#closeCampaignCreated');
        closeBtn.addEventListener('click', ()=>modalOverlay.classList.remove('active'));
    }
    // 2. Dynamic event handler (updates every time the function is called)
    const okBtn = modalOverlay.querySelector('#okCampaignCreated');
    okBtn.onclick = ()=>{
        if (onOk) onOk();
        modalOverlay.classList.remove('active');
    };
    // 3. Update text content and display
    modalOverlay.querySelector('h3').textContent = (0, _translator.i18n).t('campaign_submitted');
    modalOverlay.querySelector('p:nth-of-type(1)').textContent = (0, _translator.i18n).t('campaign_submitted_msg');
    modalOverlay.querySelector('p:nth-of-type(2)').textContent = (0, _translator.i18n).t('campaign_pending_msg');
    modalOverlay.classList.add('active');
}
function createInvoiceRow(container, invoiceData, isAdmin = false, actionHandlers = {}) {
    const temp_emptyInvoice = `<tr class="invoice-tr">
    <td class="invoice-key">${invoiceData.key}</td>
    <td class="invoice-name">${invoiceData.name}</td>
    <td class="invoice-total">$${invoiceData.usdTotal}</td>
    <td class="invoice-status ${invoiceData.status}"><span>${(0, _translator.i18n).t(invoiceData.status)}</span></td>
    <td class="invoice-date">${formatDisplayDate(invoiceData.date)}</td>
    <td class="invoice-review-date">${formatDisplayDate(invoiceData.reviewDate)}</td>
    <td class="invoice-actions">
      <!-- Shortcut 1: Manage/Edit Case Profile Popup Overlay -->
      <button
        class="btn-tr-edit ${isAdmin ? '' : 'hidden'}"
        aria-label="Edit"
        title="Edit"
        data-i18n-attr='{"aria-label":"edit","title":"edit" }'
      >
        <i
          class="fa-solid fa-pen-to-square"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>

      <button
        class="btn-tr-view"
        aria-label="View"
        title="View"
        data-i18n-attr='{"aria-label":"view","title":"view" }'
      >
        <i
          class="fa-solid fa-eye"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>

      <button
        class="btn-tr-delete ${isAdmin ? '' : 'hidden'}"
        aria-label="Delete"
        title="Delete"
        data-i18n-attr='{"aria-label":"delete","title":"delete" }'
      >
        <i
          class="fa-solid fa-trash"
          style="color: rgb(30, 48, 80)"
        ></i>
      </button>
    </td>
  </tr>`;
    const parent = document.createElement('tr');
    parent.classList.add('invoice-tr');
    parent.id = invoiceData.key;
    parent.innerHTML = temp_emptyInvoice;
    const btnEdit = parent.querySelector('.btn-tr-edit');
    const btnView = parent.querySelector('.btn-tr-view');
    const btnDelete = parent.querySelector('.btn-tr-delete');
    btnEdit.onclick = ()=>{
        if (actionHandlers.onEdit) actionHandlers.onEdit(invoiceData);
    };
    btnView.onclick = ()=>{
        if (actionHandlers.onView) actionHandlers.onView(invoiceData);
    };
    btnDelete.onclick = ()=>{
        if (actionHandlers.onDelete) actionHandlers.onDelete(invoiceData);
    };
    (0, _translator.i18n).translatePage(parent);
    const oldRow = container.querySelector(`#${invoiceData.key}`);
    if (oldRow) container.replaceChild(parent, oldRow);
    else container.appendChild(parent);
}
const temp_confirmDialog = `<dialog id="dynamicConfirmDialog" class="dialog-box">
  <div class="dialog-content">
    <h3 id="dialogTitle">Confirm Action</h3>
    <p id="dialogMessage">Are you sure you want to proceed?</p>
    <div class="dialog-actions">
      <button id="dialogCancelBtn" class="btn btn-secondary-dialog" data-i18n="cancel">Cancel</button>
      <button id="dialogConfirmBtn" class="btn" data-i18n="confirm">Confirm</button>
    </div>
  </div>
</dialog>`;
function showConfirmDialog({ title, message, confirmText = 'Confirm', cancelText = 'Cancel', confirmType = 'primary' }) {
    let dialog = document.getElementById('dynamicConfirmDialog');
    if (!dialog) {
        const container = document.createElement('div');
        container.innerHTML = temp_confirmDialog;
        dialog = container.firstChild;
        document.body.appendChild(dialog);
    }
    return new Promise((resolve)=>{
        const dialog = document.getElementById('dynamicConfirmDialog');
        const titleEl = document.getElementById('dialogTitle');
        const msgEl = document.getElementById('dialogMessage');
        const cancelBtn = document.getElementById('dialogCancelBtn');
        const confirmBtn = document.getElementById('dialogConfirmBtn');
        // 1. Inject content dynamically
        titleEl.textContent = title;
        msgEl.textContent = message;
        cancelBtn.textContent = cancelText;
        confirmBtn.textContent = confirmText;
        // 2. Set button design theme class dynamically
        confirmBtn.className = `btn ${confirmType === 'danger' ? 'btn-danger' : 'btn-primary'}`;
        // 3. Define event handlers
        const handleConfirm = ()=>{
            cleanup();
            resolve(true);
        };
        const handleCancel = ()=>{
            cleanup();
            resolve(false);
        };
        const handleBackdropClick = (e)=>{
            const rect = dialog.getBoundingClientRect();
            if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) handleCancel();
        };
        const handleKeydown = (e)=>{
            if (e.key === 'Escape') {
                e.preventDefault(); // Control behavior manually
                handleCancel();
            }
        };
        // 4. Detach event listeners to prevent memory leaks or dual resolutions
        const cleanup = ()=>{
            confirmBtn.removeEventListener('click', handleConfirm);
            cancelBtn.removeEventListener('click', handleCancel);
            dialog.removeEventListener('click', handleBackdropClick);
            dialog.removeEventListener('keydown', handleKeydown);
            dialog.close();
        };
        // 5. Attach event listeners
        confirmBtn.addEventListener('click', handleConfirm);
        cancelBtn.addEventListener('click', handleCancel);
        dialog.addEventListener('click', handleBackdropClick);
        dialog.addEventListener('keydown', handleKeydown);
        // 6. Present modal layout
        dialog.showModal();
    });
}
const temp_singleConfirmDialog = `<dialog id="singleDynamicConfirmDialog" class="dialog-box">
  <div class="dialog-content">
    <h3 id="dialogTitle" data-i18n="confirm_action">Confirm Action</h3>
    <p id="dialogMessage">Are you sure you want to proceed?</p>
    <div class="dialog-actions">
      <button id="dialogConfirmBtn" class="btn" data-i18n="confirm">Confirm</button>
    </div>
  </div>
</dialog>`;
function showSingleConfirmDialog({ title, message, confirmText = 'Confirm', confirmType = 'primary' }) {
    let dialog = document.getElementById('singleDynamicConfirmDialog');
    if (!dialog) {
        const container = document.createElement('div');
        container.innerHTML = temp_singleConfirmDialog;
        dialog = container.firstChild;
        document.body.appendChild(dialog);
    }
    return new Promise((resolve)=>{
        const dialog = document.getElementById('singleDynamicConfirmDialog');
        const titleEl = document.getElementById('dialogTitle');
        const msgEl = document.getElementById('dialogMessage');
        const confirmBtn = document.getElementById('dialogConfirmBtn');
        // 1. Inject content dynamically
        console.log('arguments: ', title, message);
        titleEl.textContent = title;
        msgEl.textContent = message;
        confirmBtn.textContent = confirmText;
        titleEl.setAttribute('data-i18n', title);
        msgEl.setAttribute('data-i18n', message);
        confirmBtn.setAttribute('data-i18n', confirmText);
        (0, _translator.i18n).translatePage(dialog);
        // 2. Set button design theme class dynamically
        confirmBtn.className = `btn ${confirmType === 'danger' ? 'btn-danger' : 'btn-primary'}`;
        // 3. Define event handlers
        const handleConfirm = ()=>{
            cleanup();
            resolve(true);
        };
        const handleCancel = ()=>{
            cleanup();
            resolve(true);
        };
        const handleBackdropClick = (e)=>{
            const rect = dialog.getBoundingClientRect();
            if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) handleCancel();
        };
        const handleKeydown = (e)=>{
            if (e.key === 'Escape') {
                e.preventDefault(); // Control behavior manually
                handleCancel();
            }
        };
        // 4. Detach event listeners to prevent memory leaks or dual resolutions
        const cleanup = ()=>{
            confirmBtn.removeEventListener('click', handleConfirm);
            dialog.removeEventListener('click', handleBackdropClick);
            dialog.removeEventListener('keydown', handleKeydown);
            dialog.close();
        };
        // 5. Attach event listeners
        confirmBtn.addEventListener('click', handleConfirm);
        dialog.addEventListener('click', handleBackdropClick);
        dialog.addEventListener('keydown', handleKeydown);
        // 6. Present modal layout
        dialog.showModal();
    });
}
function toggleSkeleton(enable = true, element) {
    if (!element) return;
    if (typeof element === 'string') element = document.body.querySelector(element);
    if (enable) element.classList.add('loading-skeleton');
    else element.classList.remove('loading-skeleton');
}

},{"../custom/translator":"eJcTf","3bfcd557e2b44a66":"lHAYc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lHAYc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6kAti");

},{}]},[], null, "parcelRequiredd39", {})

//# sourceMappingURL=public.0ff64334.js.map
